// extracted by mini-css-extract-plugin
export var falconContainer = "_wc-2";
export var offerCenter = "_wc-0";
export var roktContainer = "_wc-1";